import React, { Children, Fragment } from 'react';
import FullscreenProvider from './fullscreen/FullscreenProvider.js';
import { IMAGE_TYPE, GALLERY_TYPE } from 'wix-rich-content-common';
import 'ricos-common';
import 'wix-rich-content-fullscreen/libs/getImagesData';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RicosModal = (props) => {
  let ModalProvider = Fragment;
  let modalProps = {};
  const {
    children: {
      props: { config }
    }
  } = props;
  const { [IMAGE_TYPE]: imageConfig, [GALLERY_TYPE]: galleryConfig } = config || {};
  const needsFullscreenProvider = !(imageConfig == null ? void 0 : imageConfig.onExpand) || !(galleryConfig == null ? void 0 : galleryConfig.onExpand);
  const isExpandDisabled = (!imageConfig || imageConfig.disableExpand) && (!galleryConfig || (galleryConfig == null ? void 0 : galleryConfig.disableExpand));
  if (!isExpandDisabled && needsFullscreenProvider) {
    ModalProvider = FullscreenProvider;
    modalProps = props;
  }
  const child = Children.only(React.cloneElement(props.children, __spreadValues({}, props)));
  return /* @__PURE__ */ React.createElement(ModalProvider, __spreadValues({}, modalProps), child);
};

export { RicosModal as default };
//# sourceMappingURL=RicosModal.js.map
